<template>
  <div class="checkbox-wrapper">
    <label class="custom-checkbox" @click="handleChange">
        <span class="checkbox" :class="{ checked: value }">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check" role="img"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check fa-w-16 fa-5x"><path
                    fill="currentColor"
                    d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                    class=""></path></svg>
        </span>
        <span class="heading" v-text="label"></span>
    </label>
    <img v-if="toolTip" src="../../assets/question-icon.svg" alt="" @click="openPopup">
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import tooltipMixin from "../../mixins/tooltipMixin"; //enables tooltips

  export default {
    name: "CheckboxArdin",

    mixins: [tooltipMixin],


    props: {
      value: {
        default: () => false,
      },
      label: {
        type: String
      },
      index: {
        required: false
      },
      type: {
        type: String,
      },
      tooltip_key: {
        type: String,
        required: false,
      }
    },
    methods: {
      handleChange() {
        this.$emit('change', {
          bool: !this.value,
          index: this.index,
          type: this.type,
          label: this.label,
        });
        this.$emit('input', !this.value);
      },
      openPopup() {
        this.$store.commit('tooltips/setCurrentActive', this.toolTip);
      }
    },
    computed: {
      ...mapState({
        option: state => state.powerpackOptions.all,
      })
    }
  }
</script>

<style scoped lang="scss">

.checkbox-wrapper {
  display: flex;
  align-items: baseline !important;
  margin-right: 0.5rem;

    .custom-checkbox {
        display: flex;
        align-items: center;
        height: 38px;
        user-select: none;
        cursor: pointer;

        .checkbox {
            display: block;
            width: 17px;
            height: 17px;
            border: 2px solid #707070;
            border-radius: 3px;
            padding: 1px;

            svg {
                display: block;
                opacity: 0;
                transition: all ease 0.3s;
            }

            &.checked {
                border-color: black;

                svg {
                    opacity: 1;
                }
            }
        }

      .heading {
        font-family: neue-haas-grotesk-display, sans-serif;
        font-weight: 700;
        font-size: 12px;
        display: flex;
        padding-left: 6px;
        margin-bottom: 0;
        margin-right: 8px;
      }

    }
}
</style>
